import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuthStore } from './store/auth';
import LoginPage from './views/LoginPage';
import DashboardPage from './views/DashboardPage';

function RequireAuth({ children }: { children: JSX.Element }) {
  const isValid = useAuthStore((s) => s.isTokenValid());
  const hasCredentials =
    useAuthStore((s) => !!s.clientId) && useAuthStore((s) => !!s.clientSecret);

  // Allow access if we have stored credentials even if the token has expired —
  // the Axios interceptor will refresh it transparently on the first request.
  if (!isValid && !hasCredentials) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <DashboardPage />
          </RequireAuth>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
